import React from 'react';
import { Link, useLocation } from 'react-router-dom';

//import images
import logoSm from '../assets/images/qdosv5/App.png';
import logoDark from '../assets/images/qdosv5/qdos-logo.png';
import logoLight from '../assets/images/qdosv5/qdos-logo.png';

//import Components
import LanguageDropdown from '../Components/Common/LanguageDropdown';
import WebAppsDropdown from '../Components/Common/WebAppsDropdown';
import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import LightDark from '../Components/Common/LightDark';

import { changeSidebarVisibility } from '../store/thunks';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { RootState } from 'store';

interface PinnedModule {
    module: string;
}

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }: any) => {
    const dispatch: any = useDispatch();

    const currentRoute = useLocation().pathname.split('/').slice(1).join('/');

    const selectDashboardData = createSelector(
        (state) => state.Layout,
        (sidebarVisibilitytype) => sidebarVisibilitytype.sidebarVisibilitytype
    );
    // Inside your component
    const sidebarVisibilitytype = useSelector(selectDashboardData);
    const pinedModules = useSelector(
        (state: RootState) => state.sidebarState.pinnedModules
    );

    const toggleMenuBtn = () => {
        var windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector('.hamburger-icon') as HTMLElement;
        dispatch(changeSidebarVisibility('show'));

        if (windowSize > 767) humberIcon.classList.toggle('open');

        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === 'horizontal') {
            document.body.classList.contains('menu')
                ? document.body.classList.remove('menu')
                : document.body.classList.add('menu');
        }

        //For collapse vertical and semibox menu
        if (
            sidebarVisibilitytype === 'show' &&
            (document.documentElement.getAttribute('data-layout') === 'vertical' ||
                document.documentElement.getAttribute('data-layout') === 'semibox')
        ) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                document.documentElement.getAttribute('data-sidebar-size') === 'sm'
                    ? document.documentElement.setAttribute('data-sidebar-size', '')
                    : document.documentElement.setAttribute('data-sidebar-size', 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                document.documentElement.getAttribute('data-sidebar-size') === 'lg'
                    ? document.documentElement.setAttribute('data-sidebar-size', 'sm')
                    : document.documentElement.setAttribute('data-sidebar-size', 'lg');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }

        //Two column menu
        if (document.documentElement.getAttribute('data-layout') === 'twocolumn') {
            document.body.classList.contains('twocolumn-panel')
                ? document.body.classList.remove('twocolumn-panel')
                : document.body.classList.add('twocolumn-panel');
        }
    };



    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex  flex-column">
                            <div className="d-flex" style={{ height: '50px' }}>
                                <div className="navbar-brand-box horizontal-logo">
                                    <Link to="/" className="logo logo-dark">
                                        <span className="logo-sm">
                                            <img src={logoSm} alt="" height="22" />
                                        </span>
                                        <span className="logo-lg">
                                            <img src={logoDark} alt="" height="17" />
                                        </span>
                                    </Link>

                                    <Link to="/" className="logo logo-light">
                                        <span className="logo-sm">
                                            <img src={logoSm} alt="" height="22" />
                                        </span>
                                        <span className="logo-lg">
                                            <img src={logoLight} alt="" height="17" />
                                        </span>
                                    </Link>
                                </div>

                                <button
                                    onClick={toggleMenuBtn}
                                    type="button"
                                    className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                    id="topnav-hamburger-icon"
                                >
                                    <span className="hamburger-icon">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </span>
                                </button>

                                {/* Navigation menu - Pined */}
                                <div className="d-flex align-items-center ms-0">
                                    {pinedModules.map((item: PinnedModule, index: number) => {
                                        return (
                                            <Link
                                                to={`/${item.module.toLowerCase()}`}
                                                key={index}
                                                className={`btn btn-soft-success btn-sm ms-5 ${currentRoute === item.module.toLowerCase()
                                                        ? 'active'
                                                        : 'inactive'
                                                    }`}
                                            >
                                                {item.module}
                                            </Link>
                                        );
                                    })}
                                </div>
                            </div>

                        </div>

                        <div className="d-flex align-items-center">
                            {/* LanguageDropdown */}
                            {/* <LanguageDropdown /> */}

                            {/* WebAppsDropdown */}
                            <WebAppsDropdown />

                            {/* MyCartDropdwon */}
                            {/* <MyCartDropdown /> */}

                            {/* FullScreenDropdown */}
                            <FullScreenDropdown />

                            {/* Dark/Light Mode set */}
                            <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            />

                            {/* NotificationDropdown */}
                            <NotificationDropdown />

                            {/* ProfileDropdown */}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;
